// extracted by mini-css-extract-plugin
export default {"subtitulo":"ReaccionCrearInvitadoScreen_subtitulo__XKUoL","boton":"ReaccionCrearInvitadoScreen_boton__6gfaS","acordion":"ReaccionCrearInvitadoScreen_acordion__4lkea"};